import alt from 'components/Dispatcher';
import { hashHistory } from 'react-router';
class SearchActions{
  fetchProducts(key){
    return key;
  }
  fetchMedias(key){
    return key;
  }
  fetchAlbums(key){
    return key;
  }
  fetchFeatures(key){
    return key;
  }
  fetchUsers(key){
    return key;
  }
  clearData(tab){
    return tab;
  }
  updateProducts(products){
    return products;
  }
  updateMedias(medias){
    return medias;
  }
  updateAlbums(albums){
    return albums;
  }
  updateFeatures(features){
    return features;
  }
  updateUsers(users){
    return users;
  }
  fetchLoading() {
    return {loading: true};
  }
  updateHeight(tab,height){
    return {tab,height};
  }
  updateKeyword(keyword){
    return keyword;
  }
  updateTab(tab){
    return tab;
  }
  fetchSuccess(res) {
    if(res.status) {
      this.fetchError(res);
    } else {
      let { tab, result } = res;
      if(tab == 'product'){
        this.updateProducts(result);
      }else if(tab == 'media'){
        this.updateMedias(result)
      }else if(tab == 'album'){
        this.updateAlbums(result)
      }else if(tab == 'feature'){
        this.updateFeatures(result)
      }else if(tab == 'user'){
        this.updateUsers(result)
      }
    }
    return false;
  }
  fetchError(res) {
    if(res.status === 403) {
      hashHistory.push('/login');
    }
    return res;
  }
}

export default alt.createActions(SearchActions);



// WEBPACK FOOTER //
// ./src/actions/SearchActions.js